/* eslint-disable camelcase */
// eslint-disable-next-line no-use-before-define
import React, { useState } from "react";
import MainNavbar from "./mainNavbar";
import MainSidebar from "./mainSidebar";
import PaymentList from "./paymentList";
import Login from "./login";
import LogoPage from "./logoPage";

const MainContainer = () => {
  // I need this state to not run eslint error
  //  per visualizzare la logo page:
  // commentare  <PaymentList /> e decommentare <LogoPage />
  // eslint-disable-next-line max-len
  //  per visualizare la pagina di login commentare tutto il blocco del fragment e lasciare solo <Login /> decommentato nel return
  const [stateEx, setStateEx] = useState();
  return (
    <>
      <MainNavbar />
      <MainSidebar />
      <div className="p-4 sm:ml-64 bg-light-blue h-screen">
        <div className="mt-60 mb-40">
          <PaymentList />
          {/* <LogoPage /> */}
        </div>
      </div>
    </>
    // <Login />
  );
};

export default MainContainer;
